import React, { useState } from "react";
import { api } from "../utils/api";

function Block({ title, desc, actionLabel, onRun, busy }) {
    return (
        <div className="p-4 bg-white border rounded-2xl shadow-sm">
            <div className="font-semibold">{title}</div>
            {desc ? <p className="text-sm text-gray-600 mt-1">{desc}</p> : null}
            <div className="mt-3">
                <button
                    onClick={onRun}
                    disabled={busy}
                    className={`px-4 py-2 rounded-lg text-white font-medium ${busy ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-700"
                        }`}
                >
                    {busy ? "Đang chạy…" : actionLabel}
                </button>
            </div>
        </div>
    );
}

export default function AdminMaintenanceTools() {
    const [busy, setBusy] = useState(false);
    const [log, setLog] = useState([]);

    const append = (m) => setLog((L) => [`• ${m}`, ...L].slice(0, 200));

    async function runFixUploads() {
        try {
            setBusy(true);
            const r = await api("/admin/tools/fix-uploads", { method: "POST" });
            append(`Fix uploads: updated ${r.updated}, skipped ${r.skipped}, total ${r.total}`);
        } catch (e) {
            append(`Fix uploads lỗi: ${e.message || e}`);
        } finally { setBusy(false); }
    }

    async function runBackfillCreatedAt() {
        try {
            setBusy(true);
            const r = await api("/admin/tools/backfill-created-at", { method: "POST" });
            append(`Backfill created_at xong: services ${r.services}, posts ${r.posts}`);
        } catch (e) {
            append(`Backfill lỗi: ${e.message || e}`);
        } finally { setBusy(false); }
    }

    async function checkHealth() {
        try {
            setBusy(true);
            const t0 = performance.now();
            const r = await api("/healthz");
            const ms = Math.round(performance.now() - t0);
            append(`Healthz OK (${ms} ms): ${JSON.stringify(r)}`);
        } catch (e) {
            append(`Healthz lỗi: ${e.message || e}`);
        } finally { setBusy(false); }
    }

    return (
        <div className="max-w-4xl mx-auto p-4 sm:p-6">
            <h1 className="text-xl sm:text-2xl font-bold mb-4">🛠️ Admin Maintenance Tools</h1>

            <div className="grid gap-4 sm:grid-cols-2">
                <Block
                    title="Sửa URL ảnh về /uploads/… (posts)"
                    desc="Chuẩn hoá image_url trong bảng posts để hiển thị ổn định."
                    actionLabel="Chạy Fix Uploads"
                    onRun={runFixUploads}
                    busy={busy}
                />
                <Block
                    title="Backfill created_at"
                    desc="Điền created_at còn thiếu cho services & posts."
                    actionLabel="Chạy Backfill"
                    onRun={runBackfillCreatedAt}
                    busy={busy}
                />
                <Block
                    title="Kiểm tra API /healthz"
                    desc="Ping API qua Nginx để chắc chắn proxy hoạt động."
                    actionLabel="Check health"
                    onRun={checkHealth}
                    busy={busy}
                />
            </div>

            <div className="mt-6 bg-white border rounded-2xl p-4">
                <div className="font-semibold mb-2">Nhật ký</div>
                <div className="text-sm text-gray-800 space-y-1 max-h-64 overflow-auto leading-relaxed">
                    {log.length === 0 ? <div className="text-gray-500">Chưa có log.</div> : log.map((m, i) => <div key={i}>{m}</div>)}
                </div>
            </div>
        </div>
    );
}
